<section>
	<div class="about-us">
		<div class="container">
			<div class="row">
				<div class="col-lg-7">
					<div class="about-box">
						<div class="container">
							<div class="row" style="padding: 15px;">
								<div class="col-lg-3">
									<img src="../../assets/img/about-logo.png" alt="">
								</div>
								<div class="col" style="padding: 15px 0;">
									<span>Федерация спорта Тогызкумалак Республики Казахстан</span>
								</div>
								<div class="col-lg-12">
									<span translate style="font-size: 11px;">about-us.togyzqum</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
